/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
import type { UserStatus } from './UserStatus';
import {
    UserStatusFromJSON,
    UserStatusFromJSONTyped,
    UserStatusToJSON,
} from './UserStatus';

/**
 * 
 * @export
 * @interface UserListDto
 */
export interface UserListDto {
    /**
     * 
     * @type {number}
     * @memberof UserListDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserListDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserListDto
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserListDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserListDto
     */
    tenantId?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserListDto
     */
    roleNames?: Array<string> | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof UserListDto
     */
    status?: UserStatus;
}

/**
 * Check if a given object implements the UserListDto interface.
 */
export function instanceOfUserListDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserListDtoFromJSON(json: any): UserListDto {
    return UserListDtoFromJSONTyped(json, false);
}

export function UserListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'fullName': !exists(json, 'fullName') ? undefined : json['fullName'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'roleNames': !exists(json, 'roleNames') ? undefined : json['roleNames'],
        'status': !exists(json, 'status') ? undefined : UserStatusFromJSON(json['status']),
    };
}

export function UserListDtoToJSON(value?: UserListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'email': value.email,
        'fullName': value.fullName,
        'phoneNumber': value.phoneNumber,
        'tenantId': value.tenantId,
        'roleNames': value.roleNames,
        'status': UserStatusToJSON(value.status),
    };
}

